import { BodyText, LabelText } from '@policygenius/mortar';
import { createUseStyles } from 'react-jss';

import styles from './styles';
import { ItemProps } from './types';

const useStyles = createUseStyles(styles);

const Item = ({ label, subLabel, selected, highlighted, disabled, ...props }: ItemProps) => {
  const classes = useStyles({ selected, highlighted, disabled });

  return (
    <li key={label} className={classes.base} {...props}>
      <LabelText as="span">{label}</LabelText>
      {subLabel && <BodyText size="small">{subLabel}</BodyText>}
    </li>
  );
};

export default Item;
